module.exports = __webpack_public_path__ + "media/images/sp/stores/common/instagram/photographer_sns_04-5c6481d868243e92b8003eb48829d7f7.jpg";